var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.583,
    height: 13.583,
    viewBox: "0 0 13.583 13.583",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-fitness",
    "data-name": "Icon ionic-md-fitness",
    d: "M15.988,12.109l.97-.97-.97-.973-2.426,2.426L7.74,6.771l2.426-2.426-.97-.97-.97.97-.973-.97L5.8,4.828l-.973-.97-.97.97.97.97L3.375,7.254l.97.97-.97.973.97.97L6.771,7.74l5.822,5.822-2.426,2.426.97.97.97-.97.97.97L14.529,15.5l.97.97.97-.97-.97-.97,1.453-1.453Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#cea95a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSport);
export default __webpack_public_path__ + "static/media/sport.dc241c960f7a00ddb18262e354393d94.svg";
export { ForwardRef as ReactComponent };